import { Capacitor } from '@capacitor/core';

export const APP_URL_SCHEME = 'probell';
const AUTH_CALLBACK_PATH = '/auth/callback';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function getNativePlatform() {
  return Capacitor.getPlatform();
}

export function getAuthRedirectUrl() {
  if (typeof window === 'undefined') {
    return `${APP_URL_SCHEME}://auth/callback`;
  }
  return isNativeApp()
    ? `${APP_URL_SCHEME}://auth/callback`
    : `${window.location.origin}${AUTH_CALLBACK_PATH}`;
}

export function getAppRouteFromUrl(input: string) {
  try {
    const url = new URL(input);

    if (url.protocol === `${APP_URL_SCHEME}:`) {
      const segments = [url.host, url.pathname]
        .filter(Boolean)
        .join('/')
        .replace(/^\/+|\/+$/g, '');
      const path = segments ? `/${segments}` : '/';
      return `${path}${url.search}${url.hash}`;
    }

    if (typeof window !== 'undefined' && url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return null;
  }

  return null;
}

export async function openExternalUrl(url: string) {
  if (isNativeApp()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
    return;
  }
  window.location.href = url;
}

export async function closeExternalBrowser() {
  if (!isNativeApp()) return;
  const { Browser } = await import('@capacitor/browser');
  try {
    await Browser.close();
  } catch {
    // ignore
  }
}
